import LinkWrapper from "@/components/wrappers/Link/Link";
import { ASSETS_URL } from "@/config/deployConstants";
import { borderRadius } from "@/utils/borderRadius";
import { spacing } from "@/utils/spacing";
import { themeColors } from "@/utils/themeColors";
import { ArrowRight } from "lucide-react";
import Image from "next/image";
import { FlexColumnAlignJustifyCenter, FlexRowAlignCenter } from "@/components/Flex";
import Box from "@mui/material/Box";

type CompetitorCard = {
    name: string;
    image: string;
    description: string;
    href: string;
    imageStyle?: React.CSSProperties;
};

const competitors: CompetitorCard[] = [
    {
        name: "MagicSchool",
        image: `${ASSETS_URL}/images/MagicSchool-Logo.png`,
        description:
            "Knowt has all the same AI tools your teachers like there with necessary improvements they will love.",
        href: "/teachers/free-magic-school-alternative",
        imageStyle: { width: "43%", height: "83%" },
    },
    {
        name: "Quizizz",
        image: `${ASSETS_URL}/images/Quizizz-Logo.png`,
        description:
            "Knowt allows you to create quizzes and flashcards for your students. We also have chat assignments!",
        href: "/teachers/free-quizizz-alternative",
        imageStyle: { width: "43%", height: "90%" },
    },
    {
        name: "SchoolAI",
        image: `${ASSETS_URL}/images/SchoolAI-Logo.png`,
        description: "Build chat assignments on Knowt, and give them follow up flashcards and notes.",
        href: "/teachers/free-schoolai-alternative",
        imageStyle: { width: "50%", height: "65%" },
    },
    {
        name: "Brisk Teaching",
        image: `${ASSETS_URL}/images/Brisk-Logo.png`,
        description: "Knowt has the same AI tools with a much more interactive experience for your students.",
        href: "/teachers/free-brisk-teaching-alternative",
        imageStyle: { width: "60%", height: "100%" },
    },
    {
        name: "Quizlet",
        image: `${ASSETS_URL}/images/Quizlet-Logo.png`,
        description:
            "Knowt is the #1 alternative to Quizlet. Move flashcards over in seconds with our chrome extension.",
        href: "/teachers/free-quizlet-alternative",
        imageStyle: { width: "43%", height: "83%" },
    },
];

const CompetitorCard = (tool: CompetitorCard) => (
    <LinkWrapper key={tool.name} href={tool.href}>
        <Box
            component={"div"}
            sx={{
                "&:hover": {
                    outline: "1px solid var(--color-neutral-black)",
                },
                maxWidth: "30rem",
                display: "flex",
                flexDirection: "column",
                borderRadius: borderRadius.card,
                backgroundColor: themeColors.neutralWhite,
                padding: spacing.MD,
                gap: spacing.XS_2,
                height: "100%",
                cursor: "pointer",
            }}>
            <FlexRowAlignCenter style={{ justifyContent: "space-between" }}>
                <Image src={tool.image} alt={tool.name} width={60} height={30} style={tool.imageStyle} />
                <FlexColumnAlignJustifyCenter
                    style={{
                        backgroundColor: themeColors.pureBlack,
                        padding: spacing.XS,
                        borderRadius: borderRadius.circular,
                    }}>
                    <ArrowRight size={20} color={themeColors.pureWhite} style={{ transform: "rotate(-45deg)" }} />
                </FlexColumnAlignJustifyCenter>
            </FlexRowAlignCenter>
            <p className="secondaryText1" style={{ marginTop: "auto" }}>
                {tool.description}
            </p>
        </Box>
    </LinkWrapper>
);

const CompetitorCards = () => {
    return (
        <FlexRowAlignCenter
            style={{
                gap: spacing.MD,
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "stretch",
                width: "100%",
            }}>
            {competitors.map((competitor, index) => (
                <CompetitorCard key={index} {...competitor} />
            ))}
        </FlexRowAlignCenter>
    );
};

export default CompetitorCards;
